import React, {Fragment, useMemo, useEffect} from 'react';
import {connect} from 'react-redux';
import PortalsPanel from '../subComponents/PortalsPanel/PortalsPanel';
import ActionsPanel from '../subComponents/ActionsPanel/ActionsPanel';
import DashboardHeader from '../subComponents/DashboardHeader/DashboardHeader';
import ActionIsNotAllowedPopupContent from 'app/Components/Block/PortalsBlock/ActionIsNotAllowedPopupContent';
import {setIsShowPopup} from 'app/Components/Block/BusinessDashboardBlock/BusinessDashboardSlice';
import {getTextOrDefault} from '../../utils/functions';
import {STEPS} from '../../utils/constants';
import {isMobileOnly} from 'react-device-detect';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import gaParams from 'app/utilities/analytics/constants';
import {gaEvent} from 'app/utilities/analytics/tracking';

const OrganizationDashboard = ({
  contentData,
  portals,
  canRenderPortals,
  showScActions,
  hetPayList,
  currentStep,
  isShowPopup,
  isFullAuthenticated,
  setIsShowPopup,
  selectedHetPayId,
  companyOrgDataMap,
}) => {
  const {selfcareActionsTitle, selfcareActions} = contentData || {};
  const isOrganizationDashboard = currentStep === STEPS.ORGANIZATION_DASHBOARD;

  const actionsArr = useMemo(() => {
    const companyActions = companyOrgDataMap?.[selectedHetPayId]?.organizationBusinessSelfcareActions?.expandedValue;
    if (companyActions && companyActions.length > 0) {
      return companyActions;
    }
    return selfcareActions?.expandedValue || [];
  }, [selectedHetPayId, companyOrgDataMap, selfcareActions]);

  const isPortalCanRender = useMemo(() => {
    return isOrganizationDashboard && canRenderPortals && portals?.length > 0;
  }, [isOrganizationDashboard, canRenderPortals, portals]);

  const isActionsCanRender = useMemo(() => {
    return isOrganizationDashboard && actionsArr.length > 0 && showScActions;
  }, [isOrganizationDashboard, actionsArr, showScActions]);

  const hasSections = isPortalCanRender || isActionsCanRender;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (portals.length != 0) {
      gaEvent(
        gaParams.BUSINESS_PORTAL_REPORT_PORTAL_AMOUNT.category,
        gaParams.BUSINESS_PORTAL_REPORT_PORTAL_AMOUNT.eventType,
        portals.length,
      );
    }
  }, [portals, isFullAuthenticated, hetPayList]);

  useEffect(() => {
    portals.forEach((portal) => {
      gaEvent(gaParams.BUSINESS_PORTAL_RENDER_PORTAL.category, gaParams.BUSINESS_PORTAL_RENDER_PORTAL.eventType, portal.toString());
    });
  }, [portals]);

  return (
    <Fragment>
      <div className='organization-dashboard-container'>
        <DashboardHeader contentData={contentData} />
        {hasSections && (
          <div className='dashboard-sections-container'>
            {isPortalCanRender && <PortalsPanel portals={portals} contentData={contentData} />}
            {isActionsCanRender && (
              <ActionsPanel
                title={getTextOrDefault(selfcareActionsTitle, `${window.Config.brand_Name_HE} בשירות עצמי`)}
                actions={actionsArr}
                expandedText='הצג פחות'
                collapsedText='לכל הפעולות'
              />
            )}
          </div>
        )}
      </div>
      <PopUp
        className={`selfcare-action-not-allowed-popup ${isMobileOnly ? 'isMobile' : ''}`}
        showPopUp={isShowPopup}
        onClose={() => setIsShowPopup(false)}>
        <ActionIsNotAllowedPopupContent title='רק רגע אחד...' description={`מצטערים! אין לך הרשאה לבצע פעולה עבור חברה זו`} />
      </PopUp>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  portals: state.portalsBlock.portals,
  canRenderPortals: state.portalsBlock.canRenderPortals,
  showScActions: state.portalsBlock.showScActions,
  hetPayList: state.portalsBlock.hetPaysNumbers,
  currentStep: state.BusinessDashboardSlice.currentStep,
  isShowPopup: state.BusinessDashboardSlice.isShowPopup,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  selectedHetPayId: state.portalsBlock.selectedHetPayId,
  companyOrgDataMap: state.portalsBlock.companyOrgDataMap,
});

const mapDispatchToProps = {
  setIsShowPopup,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDashboard);
